import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Storage as StorageService } from '@core/services/storage.svc';
import { DOCUMENT, inject } from '@angular/core';
import { map } from 'rxjs';
import { GuardContextService } from '@core/services';
import { SessionAuth } from '@legacy-models/auth/user';

export const auth: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const guardContextSvc = inject(GuardContextService);
  const storageSvc = inject(StorageService);
  const router = inject(Router);
  const document = inject(DOCUMENT);
  const fullRoute = segments.map(({ path }) => path).join('/');
  const isCurrentUserAuthenticated = (user: SessionAuth | null): boolean => {
    const _isAuthenticated = !!user;
    if (!_isAuthenticated) {
      const window = document.defaultView;
      window?.sessionStorage.setItem('_returnRoute', `${window!.location.origin}/${fullRoute}`);
      router.navigate(['/login'], {
        state: {
          type: 'auth'
        }
      });
    }
    return _isAuthenticated;
  };

  if (!window.sessionStorage.getItem('currUser')) {
    guardContextSvc.context = {
      doContinuation: false
    };
  } else {
    delete guardContextSvc.context;
  }

  return storageSvc.currentUser$.pipe(map(isCurrentUserAuthenticated));
};
